import { Link } from "react-router-dom";
import { Cog, Flame, Drill, Slice, Sparkles, CircleDot, Zap, ScanLine, ArrowRight } from "lucide-react";

const MACHINES = [
  { icon: Cog, name: "Romi Discovery 600", qty: 1, type: "Centro de Usinagem Vertical",
    desc: "Centro vertical de alta rigidez para peças de médio e grande porte com precisão." },
  { icon: Cog, name: "Eurostec MCV520", qty: 1, type: "Centro de Usinagem Vertical",
    desc: "Centro de usinagem vertical para peças seriadas com alta repetibilidade." },
  { icon: Cog, name: "Romi Discovery 560", qty: 3, type: "Centro de Usinagem Vertical",
    desc: "Três centros verticais dedicados à produção seriada de peças de precisão." },
  { icon: CircleDot, name: "Torno", qty: 2, type: "Torneamento",
    desc: "Torneamento de eixos, buchas, roscas e componentes cilíndricos." },
  { icon: Drill, name: "Fresadoras ISO30 / ISO40", qty: 2, type: "Fresamento",
    desc: "Fresamento de precisão: rasgos, canais, cavidades e superfícies perfiladas." },
  { icon: Sparkles, name: "Plasma CNC", qty: 1, type: "Corte",
    desc: "Corte de chapas de aço carbono, inox e alumínio com leitura direta de DXF." },
  { icon: Zap, name: "Laser 6.000 W", qty: 1, type: "Corte",
    desc: "Corte a laser de alta potência com acabamento superior em chapas finas e médias." },
  { icon: ScanLine, name: "Laser de Gravação", qty: 1, type: "Gravação",
    desc: "Gravação e marcação permanente de peças, códigos, séries e logotipos." },
  { icon: Slice, name: "Serra Fita", qty: 1, type: "Corte",
    desc: "Corte de barras, tubos e perfis com esquadria e medida exata." },
];

const TOTAL = MACHINES.reduce((s, m) => s + m.qty, 0);

export default function Maquinas() {
  return (
    <div className="pt-[72px]" data-testid="maquinas-page">
      <section className="relative py-24 border-b border-zinc-800 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1738162837335-3745e5d16c09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxDTkMlMjBtYWNoaW5pbmclMjBtZXRhbCUyMHdvcmtzaG9wfGVufDB8fHx8MTc4OTM1NDAwOXww&ixlib=rb-4.1.0&q=85"
          alt="Parque fabril com máquinas industriais"
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/70 to-zinc-950/40" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex items-center gap-3 mb-3">
            <span className="h-px w-10 bg-orange-500" />
            <span className="mono text-xs uppercase tracking-[0.35em] text-orange-400">parque de máquinas</span>
          </div>
          <h1 className="display text-4xl sm:text-6xl font-extrabold uppercase">Nossas Máquinas</h1>
          <p className="mt-4 text-zinc-400 max-w-2xl text-sm sm:text-base leading-relaxed">
            Centros de usinagem vertical, tornos, fresadoras, corte plasma e laser,
            gravação laser e serra fita — estrutura completa para fabricar sua peça do início ao fim.
          </p>
          <div className="mt-8 flex flex-wrap gap-6">
            <div className="flex items-center gap-2 text-sm text-zinc-300">
              <Cog className="w-5 h-5 text-orange-500" /> {TOTAL} máquinas em operação
            </div>
            <div className="flex items-center gap-2 text-sm text-zinc-300">
              <Flame className="w-5 h-5 text-orange-500" /> Solda MMA · MIG · TIG · Laser
            </div>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MACHINES.map((m) => (
            <article
              key={m.name}
              data-testid={`machine-${m.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="card-tactical rounded-md p-6 hover:border-orange-900/60 transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <m.icon className="w-8 h-8 text-orange-500" strokeWidth={1.5} />
                <span className="mono text-xs text-orange-400 border border-orange-900/60 bg-orange-500/10 rounded-sm px-2 py-0.5">
                  {m.qty} un.
                </span>
              </div>
              <h2 className="display mt-4 text-xl font-bold uppercase tracking-wide">{m.name}</h2>
              <div className="mono mt-1.5 text-xs text-orange-400/90 uppercase tracking-wider">{m.type}</div>
              <p className="mt-3 text-sm text-zinc-500 leading-relaxed">{m.desc}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="pb-20 text-center px-4">
        <p className="text-zinc-400 text-sm">Precisa de uma capacidade específica? Envie seu desenho para análise.</p>
        <Link
          to="/painel/orcamentos/novo"
          data-testid="maquinas-quote-button"
          className="mt-5 inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-500 text-white font-semibold uppercase tracking-wider px-7 py-3.5 rounded-sm transition-colors"
        >
          Solicitar orçamento <ArrowRight className="w-4 h-4" />
        </Link>
      </section>
    </div>
  );
}
